import axios from "axios";
let burl = process.env.VUE_APP_API;
import {shieldHeaders} from "../http_common";

export function getIdccByCompanyName(companyName){
    return axios.get(burl+ '/api/pappers/?q=' + companyName + '&precision=exacte&par_page=50',{
        headers : shieldHeaders
    });
}
